export const shouldBypassAuth = () => {
    const onLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";

    // REACT_APP_BYPASS_AUTH=true in .env.local OR toggle via localStorage
    const flag = process.env.REACT_APP_BYPASS_AUTH === "true" ||
        localStorage.getItem("BYPASS_AUTH") === "1";

    return onLocalhost && flag;
};

export const makeFakeJWT = (hours = 24) => {
    const header = { alg: "none", typ: "JWT" };
    const payload = {
        sub: "dev-user",
        name: "Developer",
        email: "dev@local",
        exp: Math.floor(Date.now() / 1000) + hours * 3600
    };

    const b64 = (obj) => btoa(JSON.stringify(obj));
    return `${b64(header)}.${b64(payload)}.dev`;
};

export const DEV_USER = {
    id: 0,
    firstName: "Dev",
    lastName: "Bypass",
    email: "dev@local",
    isBlocked: false,
    roles: ["user"],
};
